import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInjector } from './app-injector';
import * as Sentry from "@sentry/angular";
import { RestService } from './app/services/rest.service';

Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    environment: environment.production ? 'production' : 'development',
    release: 'ciceronekiosk@1.0.0',
})

Sentry.addEventProcessor((event, hint) => {
  try {
    const restService = AppInjector?.get(RestService, null);
    const mac = restService?.mac ?? null

    event.tags = { ...event.tags, mac: mac ?? 'unknown' };
    event.contexts = {
      ...event.contexts,
      appContext: { mac },
    };
  } catch { /* evita que un fallo aquí bloquee el envío */ }

  return event;
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
